<template>
  <ul class="folders" :class="{blocked: blocked}">
    <folder
      v-for="folder in sortedFolders"
      :key="folder.foldername"
      :folder="folder"
      :i18n_label-need-sync="i18n_labelNeedSync"
    />
  </ul>
</template>

<script>

    import Folder from "./Folder.vue";

    export default {
        components: {
            Folder
        },
        props: {
            folders: null,
            blocked: null,
            i18n_labelNeedSync: String
        },
        computed: {
            sortedFolders: function(){
                return this.folders.slice().sort((a, b) => {
                    return a.foldername.localeCompare(b.foldername);
                });
            }
        }

    };
</script>

<style lang="less" scoped>

    .folders {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        list-style: none;

        li {
            padding: 10px;
            margin: 10px;
            border: 5px solid #EEE;
        }
    }

    .blocked {
        opacity: 0.5;
    }
</style>
